import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { addonFormEpic } from './addon';
import { addonManagementFormEpic } from './addonManagement';
import { fetchPostTradeWorkspaceTabsEpic } from './fetchPostTradeWorkspaceTabsEpic';
import { initializePostTradeWorkspaceEpic } from './initializePostTradeWorkspaceEpic';
import { productModificationFormEpic } from './productModification';
import { tradeAllocationFormEpic } from './tradeAllocation';
import { tradeCancellationRequestedEpic } from './tradeCancellation/tradeCancellationEpics';

export const postTradeOperationsEpics = () =>
  withAppCrashIfException(
    'postTradeOperations',
    combineEpics(
      initializePostTradeWorkspaceEpic(),
      fetchPostTradeWorkspaceTabsEpic(),
      tradeCancellationRequestedEpic(),
      addonFormEpic(),
      addonManagementFormEpic(),
      productModificationFormEpic(),
      tradeAllocationFormEpic(),
    ),
  );
